module.exports = __webpack_public_path__ + "static/media/spa.cbc845d9.svg";